import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'LogStatusModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: false,
      processing: false
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.logStatusModal.active,

      // form
      functionAnswerUuid: state => state.logStatusModal.targetId,
      values: state => state.logStatusModal.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getValue: 'logStatusModal/getValue',
    }),

    // list
    statusList () {
      return Constants.Log.ResponseStatus
    },

    // input
    inpStatus: {
      get () {
        return this.values.inpStatus
      },
      set (value) {
        this.setInputValue({
          key: 'inpStatus',
          value: value
        })
      }
    },
    inpNote: {
      get () {
        return this.values.inpNote
      },
      set (value) {
        this.setInputValue({
          key: 'inpNote',
          value: value
        })
      }
    },

    // disabled
    disableConfirmButton () {
      return false
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    confirmAccepted: function (to) {
      // 登録
      if (this.confirmKey === 'submit') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'logStatusModal/loadModel',
      hide: 'logStatusModal/hide',
      setUpdated: 'logStatusModal/setUpdated'
    }),
    ...mapMutations({
      setInputValue: 'logStatusModal/setInputValue',
    }),

    init () {
      this.loading = true

      // データ更新フラグの初期化
      this.setUpdated(false)

      // データ読出し
      this.loadModel()
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    confirmData () {
      this.showConfirm({
        key: 'submit',
        title: '',
        body: 'この内容で対応メモを保存しますか？',
        acceptLabel: '保存'
      })
    },
    postData () {
      this.processing = true

      let parameters = {
        functionAnswerUuid: this.functionAnswerUuid,
        request: {
          responseStatus: this.inpStatus,
          responseNote: this.inpNote
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['log'],
        ['v1LogResponsePut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            this.showToast({
              title: '',
              body: '対応メモを保存しました。'
            })

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })

      // データ更新フラグを有効
      // 呼び出し元のページで一覧を更新するため
      this.setUpdated(true)

      this.closeModal()
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}